import { render, staticRenderFns } from "./hometown-investment.vue?vue&type=template&id=2fa46a39&"
import script from "./hometown-investment.vue?vue&type=script&lang=js&"
export * from "./hometown-investment.vue?vue&type=script&lang=js&"
import style0 from "./hometown-investment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports